import clsx from "clsx";
import HamburgerIcon from "@ancon/wildcat-ui/shared/icons/menu.svg";

import styles from "./MainNavbar.module.scss";
import Container from "../support/container/Container";
import Button from "../support/Button";
import NavActions from "./NavActions";
import NavbarOutletSearch from "./NavbarOutletSearch";
import NavBarOrderTimeSwitch from "./NavBarOrderTimeSwitch";

function MainNavbar() {
  const isWhiteLabeled = true;
  const isNonOrderRoute = false;

  return (
    <nav
      className={clsx(styles.navContainer, {
        [styles.whiteLabeled]: isWhiteLabeled,
      })}
    >
      <Container fluid>
        <div className={styles.navLeftContainer}>
          {!isNonOrderRoute && (
            <Button className={styles.navToggle}>
              <HamburgerIcon />
            </Button>
          )}
          {/* {!isWhiteLabeled && (
            <InteractiveDiv className={styles.navBrand}>
              <img height={40} width={176} alt="logo" src={headerLogoPath} />
            </InteractiveDiv>
          )} */}
          {!isNonOrderRoute && (
            <div className={styles.actionButtonWrapper}>
              <NavbarOutletSearch />
              <NavBarOrderTimeSwitch />
            </div>
          )}
        </div>
        {/* {isWhiteLabeled && (
          <div className={styles.navMiddleContainer}>
            <InteractiveDiv className={styles.navBrand}>
              <img height={40} width={176} alt="logo" src={headerLogoPath} />
            </InteractiveDiv>
          </div>
        )} */}
        <div className={styles.navRightContainer}>
          <div className={styles.navActions}>
            <NavActions />
          </div>
        </div>
      </Container>
    </nav>
  );
}

export default MainNavbar;
